var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext } from "react";
import { ModalV2, ModalV2Content, ModalV2Title } from "../Modal";
import { CollapseContext, DropdownContext } from "../../core";
var DropdownMenuModalContent = forwardRef(function (_a, ref) {
    var label = _a.label, children = _a.children, otherProps = __rest(_a, ["label", "children"]);
    var contextValue = useContext(CollapseContext);
    var contextDropdownValue = useContext(DropdownContext);
    if (!contextValue) {
        console.warn("CollapseContext provider is needed");
        return null;
    }
    if (!contextDropdownValue) {
        console.warn("DropdownContext provider is needed");
        return null;
    }
    var expanded = contextValue.expanded, closeCollapse = contextValue.closeCollapse;
    var refButton = contextDropdownValue.refButton;
    var onClose = function () {
        if (refButton === null || refButton === void 0 ? void 0 : refButton.current) {
            refButton.current.focus();
        }
        closeCollapse();
    };
    if (!expanded) {
        return undefined;
    }
    return (React.createElement(ModalV2, __assign({ ref: ref }, otherProps, { id: "3", idModalTitle: "id", onClose: onClose }),
        React.createElement(ModalV2Content, null,
            React.createElement(ModalV2Title, { id: "id" }, label),
            children)));
});
export default DropdownMenuModalContent;
